import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import SubjectManagement from './pages/SubjectManagement';
import ReportExport from './pages/ReportExport';
import Downloads from './pages/Downloads';


import Sidebar from './components/Sidebar';
import { Box, CssBaseline } from '@mui/material';

function App() {
    const isAuthenticated = () => !!localStorage.getItem('token');
    const userRole = () => JSON.parse(localStorage.getItem('user'))?.role;

    const AdminLayout = ({ children }) => (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Sidebar />
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                {children}
            </Box>
        </Box>
    );

    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/downloads" element={<Downloads />} />

                {/* Protected Admin Routes */}
                <Route
                    path="/admin/dashboard"
                    element={isAuthenticated() && userRole() === 'admin' ? <AdminLayout><Dashboard /></AdminLayout> : <Navigate to="/login" />}
                />
                <Route
                    path="/admin/users"
                    element={isAuthenticated() && userRole() === 'admin' ? <AdminLayout><UserManagement /></AdminLayout> : <Navigate to="/login" />}
                />
                <Route
                    path="/admin/subjects"
                    element={isAuthenticated() && userRole() === 'admin' ? <AdminLayout><SubjectManagement /></AdminLayout> : <Navigate to="/login" />}
                />
                <Route
                    path="/admin/reports"
                    element={isAuthenticated() && userRole() === 'admin' ? <AdminLayout><ReportExport /></AdminLayout> : <Navigate to="/login" />}
                />

                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </Router>
    );
}

export default App;
